import styled from "styled-components";

const Rod = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-left: 2px;
  margin-right: 2px;
  padding-left: 4px;
  padding-right: 4px;
`;

export default Rod;
